import {
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger,
} from '@/ui/design-system/components/ui/collapsible';
import { FiChevronDown, FiExternalLink } from 'react-icons/fi';
import {
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubButton,
    SidebarMenuSubItem,
    useSidebar,
} from '@/ui/design-system/components/ui/sidebar';
import ExtLink from '../ExtLink';
import { RiFlaskLine } from 'react-icons/ri';

function SidebarExperimentsMenu({ isOpen: controlledOpen, onToggle }) {
    const { state, setOpen } = useSidebar();
    const open = controlledOpen ?? false;

    const handleTriggerClick = (e) => {
        if (state === 'collapsed') {
            e.preventDefault();
            onToggle?.(true);
            setOpen(true);
        }
    };

    return (
        <Collapsible
            open={open}
            onOpenChange={onToggle}
            className="group/collapsible"
        >
            <SidebarMenuItem>
                <CollapsibleTrigger asChild>
                    <SidebarMenuButton
                        tooltip="Experiments"
                        onClick={handleTriggerClick}
                    >
                        <RiFlaskLine />
                        <span>Experiments</span>
                        <FiChevronDown className="ml-auto !text-sidebar-foreground transition-transform group-data-[state=open]/collapsible:rotate-180" />
                    </SidebarMenuButton>
                </CollapsibleTrigger>
                <CollapsibleContent>
                    <SidebarMenuSub>
                        <SidebarMenuSubItem>
                            <SidebarMenuSubButton asChild>
                                <ExtLink
                                    href="https://reddit.spate.nyc/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    mixpanelContext="Experiments Reddit Insights"
                                    className="no-underline hover:no-underline"
                                >
                                    <span>Reddit Insights</span>
                                    <FiExternalLink className="ml-auto size-3 text-sidebar-foreground/50" />
                                </ExtLink>
                            </SidebarMenuSubButton>
                        </SidebarMenuSubItem>
                    </SidebarMenuSub>
                </CollapsibleContent>
            </SidebarMenuItem>
        </Collapsible>
    );
}

export default SidebarExperimentsMenu;
